import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import RegForm from './components/RegForm';
import WizardStepper from './components/WizardStepper';
import Login from './components/Login';

function App() {
  return (
    <Router>
      <div className="App">
        <header>
          <h1>FészekLak.hu</h1>
          <div style={{ fontSize: '0.9em', color: '#888', marginTop: '0.5em' }}>
            Mai dátum: {new Date().toLocaleDateString('hu-HU')} {new Date().toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' })}
          </div>
          <nav style={{ marginTop: '1em', marginBottom: '1em' }}>
            <Link to="/" style={{ marginRight: '1em', textDecoration: 'none', color: '#007bff' }}>Bejelentkezés</Link>
            <Link to="/register" style={{ textDecoration: 'none', color: '#007bff' }}>Regisztráció</Link>
          </nav>
        </header>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<RegForm />} />
          <Route path="/wizard" element={<WizardStepper />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;